<script setup lang="ts">
import { ref } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { login } from '../api'

const username = ref('')
const password = ref('')
const error = ref<string | null>(null)
const submitting = ref(false)

const router = useRouter()
const route = useRoute()

async function onSubmit() {
  error.value = null
  submitting.value = true
  try {
    await login(username.value, password.value)
    const next = (route.query.next as string) || '/'
    router.push(next)
  } catch (e: any) {
    error.value = e?.response?.status === 401
      ? 'Benutzername oder Passwort falsch.'
      : 'Anmeldung fehlgeschlagen. Bitte erneut versuchen.'
  } finally {
    submitting.value = false
  }
}
</script>

<template>
  <form class="card" @submit.prevent="onSubmit">
    <img src="/logo.svg" alt="" class="logo" />
    <h1>UroFlow</h1>
    <p class="muted">Anmeldung für klinischen Zugang</p>

    <label>
      <span>Benutzername</span>
      <input v-model="username" autocomplete="username" autofocus required />
    </label>

    <label>
      <span>Passwort</span>
      <input v-model="password" type="password" autocomplete="current-password" required />
    </label>

    <p v-if="error" class="error">{{ error }}</p>

    <button class="primary" type="submit" :disabled="submitting">
      {{ submitting ? 'Bitte warten…' : 'Anmelden' }}
    </button>
  </form>
</template>

<style scoped>
.card {
  width: 100%;
  max-width: 380px;
  background: var(--color-surface);
  border: 1px solid var(--color-border);
  border-radius: var(--radius);
  box-shadow: var(--shadow-md);
  padding: 36px 32px;
  display: flex;
  flex-direction: column;
  gap: 14px;
}
.logo { height: 44px; width: auto; align-self: flex-start; margin-bottom: 4px; }
h1 { font-family: var(--font-display); font-size: 26px; font-weight: 500; letter-spacing: 0.01em; }
.muted { margin: 0 0 10px 0; color: var(--color-muted); font-size: 13px; }
label { display: flex; flex-direction: column; gap: 6px; font-size: 13px; }
label span { color: var(--color-muted); font-size: 12px; }
.error {
  background: #f9eae6;
  color: var(--color-danger);
  padding: 9px 12px;
  border-radius: var(--radius);
  font-size: 13px;
  margin: 0;
}
button { margin-top: 8px; }
</style>
